export const recurFrequency = [
  // {id: "hourly", display: "Hourly"},
  {id: "daily", display: "Daily"},
  {id: "weekly", display: "Weekly"},
  // {id: "monthly", display: "Monthly"},
  // {id: "yearly", display: "Yearly"}
];

export const recurStopList = [
  // {id: "hourly", display: "Hourly"},
  {id: "by", display: "By"},
  {id: "after", display: "After"},
  // {id: "monthly", display: "Monthly"},
  // {id: "yearly", display: "Yearly"}
];

export const calendarCancelOptions = [
  {id: "CANX", display: "Cancelled"},
];

export const calendarRescheduleOptions = [
  {id: "CLIENTCANX", display: "Client Cancelled"},
  {id: "REPCANX", display: "Rep Cancelled"},
  {id: "PUSHBACK", display: "Push Back"},
  {id: "NOSHOW", display: "No Show"}
];

export const templateChoices = [
  "Add", "Change", "Reschedule", "Reminder", "Cancel"
]

export const howHearOptions = [
  "Social Media",
  "Text Message",
  "Phone Call",
  "Email",
  "Road Sign",
  "Billboard",
  "MWR event",
  "Friend",
  "Mail (postcard)"
].sort().map((item) => ({id: item, display: item}));


// WEBPACK FOOTER //
// ./src/containers/Calendar/constants/CalendarConstants.js